const sliceNames = {
    claimSlice: 'claim',
    appStateSlice: 'appState',
};

export default sliceNames;
